import { atom } from 'recoil';

export type combatTabs = 'equipment' | 'loadout' | 'inventory' | 'ammunition' | 'fight' | 'combat' | number;

export const combatZoneAtom = atom({ key: 'combatZoneTab', default: 'equipment' as combatTabs });
